module.exports = __webpack_public_path__ + "img/rocket-icon.0b0b0e98.svg";